// Videos ahora son enlaces de YouTube

export const streamingProjects = [
  {
    id: 2,
    title: {
      es: "Molestando a Amigos",
      en: "Teasing Friends"
    },
    category: {
      es: "Collab",
      en: "Collab"
    },
    video: "https://www.youtube.com/watch?v=OqHrIP7x12A",
    image: "/images/Frente.jpg",
    tags: ["League of Legends", "Humor"],
    clipInfo: {
      es: "Clip de Fuvu y Danez43",
      en: "Clip by Fuvu and Danez43"
    },
    clipLink: "https://www.instagram.com/p/DOW2dsAgXpJ/",
    creator: "danez",
    link: "#",
    isYoutube: true,
    format: "short"
  },
  {
    id: 5,
    title: {
      es: "Clip Destacado de Sana",
      en: "Featured Clip from Sana"
    },
    category: {
      es: "Juego de terror",
      en: "Horror game"
    },
    video: "https://www.instagram.com/reel/DQaJTg8Dov_/",
    image: "/images/Sana-susto-miniatura0.png",
    tags: ["Streaming", "Humor"],
    clipInfo: {
      es: "Clip de Sana",
      en: "Clip by Sana"
    },
    clipLink: "https://www.instagram.com/reel/DQaJTg8Dov_/",
    creator: "sana",
    link: "#",
    videoFile: "/videos/ig_DQaJTg8Dov_.mp4",
    format: "short"
  },
  {
    id: 9,
    title: {
      es: "Clip Destacado de Zago",
      en: "Featured Clip from Zago"
    },
    category: {
      es: "Interacción con el chat",
      en: "Chat interaction"
    },
    video: "https://www.instagram.com/p/Da6IbbDlbHG/",
    image: "/images/ig_Da6IbbDlbHG.jpg",
    tags: ["Kingdom Come: Deliverance II", "Humor"],
    clipInfo: {
      es: "Clip de Zago",
      en: "Clip by Zago"
    },
    clipLink: "https://www.instagram.com/p/Da6IbbDlbHG/",
    creator: "zago",
    link: "#",
    videoFile: "/videos/ig_Da6IbbDlbHG.mp4",
    format: "short"
  },
  {
    id: 10,
    title: {
      es: "Short Destacado",
      en: "Featured Short"
    },
    category: {
      es: "Gameplay",
      en: "Gameplay"
    },
    video: "https://www.youtube.com/shorts/GuvJ8y_Eqt8",
    image: "/images/3 wards.png",
    tags: ["League of Legends", "Humor"],
    clipInfo: {
      es: "Clip de Danez43",
      en: "Clip by Danez43"
    },
    clipLink: "https://www.instagram.com/p/DSddWTkgsq_/",
    creator: "danez",
    link: "#",
    isYoutube: true,
    format: "short"
  },
  {
    id: 4,
    title: {
      es: "Clip Destacado de Danez",
      en: "Featured Clip from Danez"
    },
    category: {
      es: "Gameplay",
      en: "Gameplay"
    },
    video: "https://www.youtube.com/watch?v=TTdzua7PLaM",
    image: "/images/el_verdulero.jpg",
    tags: ["League of Legends", "Humor"],
    clipInfo: {
      es: "Clip de Danez43",
      en: "Clip by Danez43"
    },
    clipLink: "https://www.instagram.com/p/DPUZxSuARZz/",
    creator: "danez",
    link: "#",
    isYoutube: true,
    format: "short"
  },
  {
    id: 8,
    title: {
      es: "Intentamos escalar en PEAK… y terminó en puro caos",
      en: "We Tried to Climb in PEAK… and It Ended in Total Chaos"
    },
    category: {
      es: "Gameplay",
      en: "Gameplay"
    },
    video: "https://www.youtube.com/watch?v=1zFL9SFd54M",
    image: "https://img.youtube.com/vi/1zFL9SFd54M/maxresdefault.jpg",
    tags: ["Edicion simple", "Simple Editing"],
    clipInfo: {
      es: "Canal: Niiniiwi",
      en: "Channel: Niiniiwi"
    },
    clipLink: "https://www.youtube.com/watch?v=1zFL9SFd54M&t=13s",
    link: "#",
    isYoutube: true,
    format: "video"
  },
  {
    id: 11,
    title: {
      es: "Minecraft y el arte de contar mil veces una misma historia",
      en: "Minecraft and the Art of Telling the Same Story a Thousand Times"
    },
    category: {
      es: "Storytelling",
      en: "Storytelling"
    },
    video: "https://www.youtube.com/watch?v=2VcGkyLoI6k&t=4s",
    image: "https://img.youtube.com/vi/2VcGkyLoI6k/maxresdefault.jpg",
    tags: ["Edicion compleja", "Complex Editing"],
    clipInfo: {
      es: "Canal: Danez43",
      en: "Channel: Danez43"
    },
    clipLink: "https://www.youtube.com/watch?v=2VcGkyLoI6k&t=4s",
    link: "#",
    isYoutube: true,
    format: "video"
  },
  {
    id: 30,
    title: {
      es: "Redebut VTuber de Fuvu (resumen)",
      en: "Fuvu's VTuber Redebut (Recap)"
    },
    category: {
      es: "Resumen de stream",
      en: "Stream recap"
    },
    video: "https://www.youtube.com/watch?v=gwTBf9SRRxc",
    image: "https://img.youtube.com/vi/gwTBf9SRRxc/maxresdefault.jpg",
    tags: ["VTuber", "Streaming"],
    clipInfo: {
      es: "Canal: Fuvu'sChannel",
      en: "Channel: Fuvu'sChannel"
    },
    clipLink: "https://youtu.be/gwTBf9SRRxc",
    link: "#",
    isYoutube: true,
    format: "video"
  },
  {
    id: 27,
    title: {
      es: "Siendo esclavizado de 1000 formas distintas | Carpincho SMP",
      en: "Enslaved in 1,000 Different Ways | Carpincho SMP"
    },
    category: {
      es: "Gameplay",
      en: "Gameplay"
    },
    video: "https://www.youtube.com/watch?v=UWBVLmjHRtU",
    image: "https://img.youtube.com/vi/UWBVLmjHRtU/maxresdefault.jpg",
    tags: ["Minecraft", "Humor"],
    clipInfo: {
      es: "Canal: ZagoNor",
      en: "Channel: ZagoNor"
    },
    clipLink: "https://www.youtube.com/watch?v=UWBVLmjHRtU",
    link: "#",
    isYoutube: true,
    format: "video"
  },
  {
    id: 28,
    title: {
      es: "GTA 6 rompe el concepto de mundo abierto",
      en: "GTA 6 Breaks the Open-World Concept"
    },
    category: {
      es: "Análisis",
      en: "Analysis"
    },
    video: "https://www.youtube.com/watch?v=WLnLY4yfrro",
    image: "https://img.youtube.com/vi/WLnLY4yfrro/maxresdefault.jpg",
    tags: ["GTA 6"],
    clipInfo: {
      es: "Canal: Código VI",
      en: "Channel: Código VI"
    },
    clipLink: "https://www.youtube.com/watch?v=WLnLY4yfrro",
    link: "#",
    isYoutube: true,
    format: "video"
  },
  {
    id: 12,
    title: {
      es: "Puntuando los alfajores argentinos",
      en: "Rating Argentine Alfajores"
    },
    category: {
      es: "Charla humorística",
      en: "Comedy talk"
    },
    video: "https://www.youtube.com/watch?v=hfyngrnqSxs",
    image: "https://img.youtube.com/vi/hfyngrnqSxs/maxresdefault.jpg",
    tags: ["Edicion simple", "Simple Editing"],
    clipInfo: {
      es: "Canal: Danez43",
      en: "Channel: Danez43"
    },
    clipLink: "https://www.youtube.com/watch?v=hfyngrnqSxs",
    link: "#",
    isYoutube: true,
    format: "video"
  },
  {
    id: 20,
    title: { es: "Clip de Zago 2", en: "Clip by Zago 2" },
    category: { es: "Gameplay", en: "Gameplay" },
    video: "https://www.instagram.com/p/DZx-yF_B5eE/",
    image: "/images/ig_DZx-yF_B5eE.jpg",
    tags: ["Minecraft", "Cobblemon", "Humor"],
    clipInfo: { es: "Clip de Zago", en: "Clip by Zago" },
    clipLink: "https://www.instagram.com/p/DZx-yF_B5eE/",
    link: "#",
    videoFile: "/videos/ig_DZx-yF_B5eE.mp4",
    creator: "zago",
    format: "short"
  },
  {
    id: 21,
    title: { es: "Clip de Zago 3", en: "Clip by Zago 3" },
    category: { es: "Gameplay", en: "Gameplay" },
    video: "https://www.instagram.com/p/DYp4lHqhmCb/",
    image: "/images/ig_DYp4lHqhmCb.jpg",
    tags: ["Streaming", "Humor"],
    clipInfo: { es: "Clip de Zago", en: "Clip by Zago" },
    clipLink: "https://www.instagram.com/p/DYp4lHqhmCb/",
    link: "#",
    videoFile: "/videos/ig_DYp4lHqhmCb.mp4",
    creator: "zago",
    format: "short"
  },
  {
    id: 22,
    title: { es: "Clip de Sana 2", en: "Clip by Sana 2" },
    category: { es: "Interacción con el chat", en: "Chat interaction" },
    video: "https://www.instagram.com/p/DQcgQc5DnVA/",
    image: "/images/ig_DQcgQc5DnVA.jpg",
    tags: ["Streaming", "Humor"],
    clipInfo: { es: "Clip de Sana", en: "Clip by Sana" },
    clipLink: "https://www.instagram.com/p/DQcgQc5DnVA/",
    link: "#",
    videoFile: "/videos/ig_DQcgQc5DnVA.mp4",
    creator: "sana",
    format: "short"
  },
  {
    id: 23,
    title: { es: "Clip de Sana 3", en: "Clip by Sana 3" },
    category: { es: "Canje de puntos", en: "Channel points" },
    video: "https://www.instagram.com/p/DPHUI47jiKP/",
    image: "/images/ig_DPHUI47jiKP.jpg",
    tags: ["Streaming", "Humor"],
    clipInfo: { es: "Clip de Sana", en: "Clip by Sana" },
    clipLink: "https://www.instagram.com/p/DPHUI47jiKP/",
    link: "#",
    videoFile: "/videos/ig_DPHUI47jiKP.mp4",
    creator: "sana",
    format: "short"
  },
  {
    id: 24,
    title: { es: "Clip Destacado de Fuvu", en: "Featured Clip from Fuvu" },
    category: { es: "Anécdota", en: "Storytime" },
    video: "https://www.instagram.com/p/DS0gV1zCKcd/",
    image: "/images/ig_DS0gV1zCKcd.jpg",
    tags: ["Streaming", "Humor"],
    clipInfo: { es: "Clip de Fuvu", en: "Clip by Fuvu" },
    clipLink: "https://www.instagram.com/p/DS0gV1zCKcd/",
    link: "#",
    videoFile: "/videos/ig_DS0gV1zCKcd.mp4",
    creator: "fuvu",
    format: "short"
  },
  {
    id: 25,
    title: { es: "Clip de Fuvu 2", en: "Clip by Fuvu 2" },
    category: { es: "Anécdota", en: "Storytime" },
    video: "https://www.instagram.com/p/DPmkxeYkeMi/",
    image: "/images/ig_DPmkxeYkeMi.jpg",
    tags: ["Streaming", "Humor"],
    clipInfo: { es: "Clip de Fuvu", en: "Clip by Fuvu" },
    clipLink: "https://www.instagram.com/p/DPmkxeYkeMi/",
    link: "#",
    videoFile: "/videos/ig_DPmkxeYkeMi.mp4",
    creator: "fuvu",
    format: "short"
  },
  {
    id: 26,
    title: { es: "Clip de Fuvu 3", en: "Clip by Fuvu 3" },
    category: { es: "Gameplay", en: "Gameplay" },
    video: "https://www.instagram.com/p/DTYoBbhCGVm/",
    image: "/images/ig_DTYoBbhCGVm.jpg",
    tags: ["Minecraft", "Humor"],
    clipInfo: { es: "Clip de Fuvu", en: "Clip by Fuvu" },
    clipLink: "https://www.instagram.com/p/DTYoBbhCGVm/",
    link: "#",
    videoFile: "/videos/ig_DTYoBbhCGVm.mp4",
    creator: "fuvu",
    format: "short"
  },
  {
    id: 31,
    title: { es: "Clip Destacado de Darkry", en: "Featured Clip from Darkry" },
    category: { es: "Gameplay", en: "Gameplay" },
    video: "https://www.instagram.com/p/Dd7KIRhIY1d/",
    image: "/images/ig_Dd7KIRhIY1d.jpg",
    tags: ["Minecraft", "Humor"],
    clipInfo: { es: "Clip de Darkry", en: "Clip by Darkry" },
    clipLink: "https://www.instagram.com/p/Dd7KIRhIY1d/",
    link: "#",
    videoFile: "/videos/ig_Dd7KIRhIY1d.mp4",
    creator: "darkry",
    format: "short"
  },
  {
    id: 32,
    title: { es: "Clip de Darkry 2", en: "Clip by Darkry 2" },
    category: { es: "Gameplay", en: "Gameplay" },
    video: "https://www.instagram.com/p/DeQFF3eIET-/",
    image: "/images/ig_DeQFF3eIET-.jpg",
    tags: ["Minecraft", "VTuber", "Humor"],
    clipInfo: { es: "Clip de Darkry", en: "Clip by Darkry" },
    clipLink: "https://www.instagram.com/p/DeQFF3eIET-/",
    link: "#",
    videoFile: "/videos/ig_DeQFF3eIET-.mp4",
    creator: "darkry",
    format: "short"
  },
  {
    id: 33,
    title: { es: "Clip de Darkry 3", en: "Clip by Darkry 3" },
    category: { es: "Interacción con el chat", en: "Chat interaction" },
    video: "https://www.instagram.com/p/DeaqUwaIZWF/",
    image: "/images/ig_DeaqUwaIZWF.jpg",
    tags: ["VTuber", "Humor"],
    clipInfo: { es: "Clip de Darkry", en: "Clip by Darkry" },
    clipLink: "https://www.instagram.com/p/DeaqUwaIZWF/",
    link: "#",
    videoFile: "/videos/ig_DeaqUwaIZWF.mp4",
    creator: "darkry",
    format: "short"
  }
];

export const professionalProjects = [
  {
    id: 1,
    title: {
      es: "Curita",
      en: "Curita"
    },
    category: {
      es: "Cortometraje",
      en: "Short film"
    },
    video: "https://www.youtube.com/watch?v=J2ob4f8whHU",
    image: "/images/curita.jpg",
    tags: ["Trabajo", "Work"],
    clipInfo: {
      es: "Clip Profesional",
      en: "Professional Clip"
    },
    link: "#",
    isYoutube: true,
    format: "cine"
  },
  {
    id: 8,
    title: {
      es: "Papá Todo Terreno",
      en: "All-Terrain Dad"
    },
    category: {
      es: "Día del Padre",
      en: "Father's Day"
    },
    // El post de Instagram fue dado de baja: se reproduce el archivo local
    videoFile: "/videos/papa-todo-terreno.mp4",
    creator: "soymat",
    image: "/images/ig_DZI45timDYO.jpg",
    tags: ["Motion graphics", "Subtitulado", "Montaje dinámico", "Edición compleja"],
    clipInfo: {
      es: "Trabajo realizado: corrección de color y corte",
      en: "Work done: color correction and editing"
    },
    link: "#",
    format: "spot"
  },
  {
    id: 12,
    title: {
      es: "Activación de marca en la Bienal",
      en: "Brand Activation at the Bienal"
    },
    category: {
      es: "Cobertura de evento",
      en: "Event coverage"
    },
    video: "https://www.instagram.com/p/DbOmZSuCARc/",
    image: "/images/ig_DbOmZSuCARc.jpg",
    tags: ["Publicidad", "Edición"],
    clipInfo: {
      es: "Cliente: @somossoymat",
      en: "Client: @somossoymat"
    },
    clipLink: "https://www.instagram.com/p/DbOmZSuCARc/",
    creator: "soymat",
    link: "#",
    videoFile: "/videos/ig_DbOmZSuCARc.mp4",
    format: "spot"
  },
  {
    id: 13,
    title: {
      es: "So&Mat en la Bienal 2026",
      en: "So&Mat at Bienal 2026"
    },
    category: {
      es: "Resumen de evento",
      en: "Event recap"
    },
    video: "https://www.instagram.com/p/DbUOORJjIRt/",
    image: "/images/ig_DbUOORJjIRt.jpg",
    tags: ["Publicidad", "Edición"],
    clipInfo: {
      es: "Cliente: @somossoymat",
      en: "Client: @somossoymat"
    },
    clipLink: "https://www.instagram.com/p/DbUOORJjIRt/",
    creator: "soymat",
    link: "#",
    videoFile: "/videos/ig_DbUOORJjIRt.mp4",
    format: "spot"
  }
];

export const irlProjects = [
  {
    id: 34,
    title: { es: "Más barato que Backmarket", en: "Cheaper than Backmarket" },
    category: { es: "Vlog de compraventa", en: "Resale vlog" },
    video: "https://www.instagram.com/reel/DZdSF6eOfi_/",
    image: "/images/ig_DZdSF6eOfi_.jpg",
    tags: ["Motion graphics", "Montaje dinámico", "Edición simple"],
    clipInfo: { es: "Trabajo realizado: corte y subtitulado", en: "Work done: cutting and subtitling" },
    clipLink: "https://www.instagram.com/reel/DZdSF6eOfi_/",
    link: "#",
    videoFile: "/videos/ig_DZdSF6eOfi_.mp4",
    creator: "adri"
  },
  {
    id: 35,
    title: { es: "Su padre no estaba convencido", en: "His Dad Wasn't Convinced" },
    category: { es: "Vlog de compraventa", en: "Resale vlog" },
    video: "https://www.instagram.com/reel/DdHFhpitP2z/",
    image: "/images/ig_DdHFhpitP2z.jpg",
    tags: ["Motion graphics", "Montaje dinámico", "Edición simple"],
    clipInfo: { es: "Trabajo realizado: corte y subtitulado", en: "Work done: cutting and subtitling" },
    clipLink: "https://www.instagram.com/reel/DdHFhpitP2z/",
    link: "#",
    videoFile: "/videos/ig_DdHFhpitP2z.mp4",
    creator: "adri"
  },
  {
    id: 36,
    title: { es: "Venta bajo la lluvia", en: "A Sale in the Rain" },
    category: { es: "Vlog de compraventa", en: "Resale vlog" },
    video: "https://www.instagram.com/reel/DYhlAJgNWeb/",
    image: "/images/ig_DYhlAJgNWeb.jpg",
    tags: ["Motion graphics", "Montaje dinámico", "Edición simple"],
    clipInfo: { es: "Trabajo realizado: corte y subtitulado", en: "Work done: cutting and subtitling" },
    clipLink: "https://www.instagram.com/reel/DYhlAJgNWeb/",
    link: "#",
    videoFile: "/videos/ig_DYhlAJgNWeb.mp4",
    creator: "adri"
  },
  {
    id: 37,
    title: { es: "Me pagan 300 € y pasa esto", en: "They Pay Me €300 and This Happens" },
    category: { es: "Vlog de compraventa", en: "Resale vlog" },
    video: "https://www.instagram.com/reel/DZknemUNcLl/",
    image: "/images/ig_DZknemUNcLl.jpg",
    tags: ["Motion graphics", "Montaje dinámico", "Edición simple"],
    clipInfo: { es: "Trabajo realizado: corte y subtitulado", en: "Work done: cutting and subtitling" },
    clipLink: "https://www.instagram.com/reel/DZknemUNcLl/",
    link: "#",
    videoFile: "/videos/ig_DZknemUNcLl.mp4",
    creator: "adri"
  },
  {
    id: 38,
    title: { es: "Me pagó de más", en: "He Overpaid Me" },
    category: { es: "Vlog de compraventa", en: "Resale vlog" },
    video: "https://www.instagram.com/reel/Db6aML1OUqC/",
    image: "/images/ig_Db6aML1OUqC.jpg",
    tags: ["Motion graphics", "Montaje dinámico", "Edición simple"],
    clipInfo: { es: "Trabajo realizado: corte y subtitulado", en: "Work done: cutting and subtitling" },
    clipLink: "https://www.instagram.com/reel/Db6aML1OUqC/",
    link: "#",
    videoFile: "/videos/ig_Db6aML1OUqC.mp4",
    creator: "adri"
  },
  {
    id: 39,
    title: { es: "Todo iba bien hasta que…", en: "Everything Was Fine Until…" },
    category: { es: "Vlog de compraventa", en: "Resale vlog" },
    video: "https://www.instagram.com/reel/DY4vO3FNXzY/",
    image: "/images/ig_DY4vO3FNXzY.jpg",
    tags: ["Motion graphics", "Montaje dinámico", "Edición simple"],
    clipInfo: { es: "Trabajo realizado: corte y subtitulado", en: "Work done: cutting and subtitling" },
    clipLink: "https://www.instagram.com/reel/DY4vO3FNXzY/",
    link: "#",
    videoFile: "/videos/ig_DY4vO3FNXzY.mp4",
    creator: "adri"
  },
  {
    id: 9,
    title: {
      es: "Vendiendo un iPhone 16",
      en: "Selling an iPhone 16"
    },
    category: {
      es: "Vlog de compraventa",
      en: "Resale vlog"
    },
    video: "https://www.instagram.com/reel/DZ-2YCHOcBh/",
    image: "/images/ig_DZ-2YCHOcBh.jpg",
    tags: ["Motion graphics", "Montaje dinámico", "Edición simple"],
    clipInfo: {
      es: "Trabajo realizado: corte y subtitulado",
      en: "Work done: cutting and subtitling"
    },
    clipLink: "https://www.instagram.com/reel/DZ-2YCHOcBh/",
    link: "#",
    videoFile: "/videos/ig_DZ-2YCHOcBh.mp4",
    creator: "adri"
  },
  {
    id: 10,
    title: {
      es: "Venta a un cliente de Ciudad Real",
      en: "Sale to a Buyer from Ciudad Real"
    },
    category: {
      es: "Vlog de compraventa",
      en: "Resale vlog"
    },
    video: "https://www.instagram.com/reel/DaIq_1Vtp4a/",
    image: "/images/ig_DaIq_1Vtp4a.jpg",
    tags: ["Motion graphics", "Montaje dinámico", "Edición simple"],
    clipInfo: {
      es: "Trabajo realizado: corte y subtitulado",
      en: "Work done: cutting and subtitling"
    },
    clipLink: "https://www.instagram.com/reel/DaIq_1Vtp4a/",
    link: "#",
    videoFile: "/videos/ig_DaIq_1Vtp4a.mp4",
    creator: "adri"
  },
  {
    id: 11,
    title: {
      es: "Comprando y revisando un iPhone",
      en: "Buying and Checking an iPhone"
    },
    category: {
      es: "Vlog de compraventa",
      en: "Resale vlog"
    },
    video: "https://www.instagram.com/reel/DZvZzd_uxlm/",
    image: "/images/ig_DZvZzd_uxlm.jpg",
    tags: ["Motion graphics", "Montaje dinámico", "Edición simple"],
    clipInfo: {
      es: "Trabajo realizado: corte y subtitulado",
      en: "Work done: cutting and subtitling"
    },
    clipLink: "https://www.instagram.com/reel/DZvZzd_uxlm/",
    link: "#",
    videoFile: "/videos/ig_DZvZzd_uxlm.mp4",
    creator: "adri"
  }
];
